package ui.composables

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import org.jetbrains.compose.resources.painterResource
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.dating
import thewedding_cmp.composeapp.generated.resources.engangement
import thewedding_cmp.composeapp.generated.resources.meet
import thewedding_cmp.composeapp.generated.resources.wedding

@Composable
fun LoveStoryDialog(
    show: Boolean,
    onDismiss: () -> Unit,
) {
    if (!show) return

    // index story
    var currentStep by remember { mutableStateOf(0) }

    // data story (4 step)
    val stories = listOf(
        Triple(Res.drawable.meet, "05 Aug 2023 - First Meet", "Kami dipertemukan dalam suatu kesempatan dan mulai tertarik satu sama lain."),
        Triple(Res.drawable.dating, "20 Jan 2024 - Official Date", "Kami menjadi lebih dekat dalam sebuah hubungan yang penuh cinta."),
        Triple(Res.drawable.engangement, "01 Nov 2025 - Engagement", "Kami berkomitmen untuk membangun masa depan bersama."),
        Triple(Res.drawable.wedding, "05 Apr 2026 - Wedding", "Kami mengikat janji suci untuk hidup bersama sebagai suami istri.")
    )

    val (icon, title, message) = stories[currentStep]

    Dialog(
        onDismissRequest = {
            currentStep = 0
            onDismiss()
        },
        properties = DialogProperties(usePlatformDefaultWidth = false)
    ) {
        Card(
            shape = RoundedCornerShape(16.dp),
            elevation = CardDefaults.cardElevation(8.dp),
            modifier = Modifier
                .padding(18.dp)
                .widthIn(max = 500.dp)
        ) {
            Column(
                modifier = Modifier.padding(24.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                Image(
                    painterResource(icon),
                    contentDescription = null,
                    modifier = Modifier.size(200.dp)
                )

                Spacer(Modifier.height(16.dp))

                Text(
                    text = title,
                    style = MaterialTheme.typography.titleMedium.copy(
                        fontSize = 18.sp
                    ),
                    fontWeight = FontWeight.Bold
                )

                Spacer(Modifier.height(8.dp))

                Text(
                    text = message,
                    style = MaterialTheme.typography.bodyMedium.copy(
                        fontSize = 16.sp
                    ),
                    textAlign = TextAlign.Center,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )

                Spacer(Modifier.height(24.dp))

                Button(
                    onClick = {
                        if (currentStep < stories.lastIndex) {
                            currentStep++
                        } else {
                            // selesai
                            currentStep = 0
                            onDismiss()
                        }
                    },
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(12.dp)
                ) {
                    Text(if (currentStep == stories.lastIndex) "Finish" else "Next")
                }
            }
        }
    }
}